<template>
	<view class="flex-col page">
		<!-- #ifdef APP-PLUS -->
		<view class="status_bar">
			<view class="top_view"></view>
		</view>
		<!-- #endif -->
		<view class="top_nav">
			<image src="/static/local/3546451940011a031009b939a8b26314.png" class="image_1" @click="pageBack" />
			<view class="cate">广场</view>
		</view>
		<view class="flex-col group_1">
			<view class="justify-between group_2" @click="navigateTo('/pages/mine/square/release', false)">
				<text>我的发布</text>
				<image src="/static/remote/59d50f245e774077b29cc12824c65db5.png" class="image_2" />
			</view>
			<view class="flex-col">
				<image src="/static/local/0cec384fa1c7befc3fb0a06c13233461.png" class="image_4" />
				<view class="top-group justify-between"
					@click="navigateTo('/pages/mine/square/comment-and-thumbsup', false)">
					<text class="like" :class="{have_mark: vk.getVuex('$app.likeBadge')}">评论和点赞</text>
					<image src="/static/remote/59d50f245e774077b29cc12824c65db5.png" class="image_2" />
				</view>
				<view class="flex-col">
					<image src="/static/local/0cec384fa1c7befc3fb0a06c13233461.png" class="image_4" />
					<view class="top-group justify-between" @click="navigateTo('/pages/mine/square/collection', false)">
						<text>我的收藏</text>
						<image src="/static/remote/59d50f245e774077b29cc12824c65db5.png" class="image_2" />
					</view>
					<image src="/static/local/0cec384fa1c7befc3fb0a06c13233461.png" class="image_4" />
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	var that; // 当前页面对象
	var vk; // vk依赖
	export default {
		data() {
			// 页面数据变量
			return {}
		},
		// 监听 - 页面每次【加载时】执行(如：前进)
		onLoad(options = {}) {
			that = this;
			vk = that.vk;
			that.init(options)
		},
		// 监听 - 页面【首次渲染完成时】执行。注意如果渲染速度快，会在页面进入动画完成前触发
		onReady() {},
		// 监听 - 页面每次【显示时】执行(如：前进和返回) (页面每次出现在屏幕上都触发，包括从下级页面点返回露出当前页面)
		onShow() {},
		// 监听 - 页面每次【隐藏时】执行(如：返回)
		onHide() {},
		// 函数
		methods: {
			// 页面数据初始化函数
			init(options) {},
			pageBack() {
				uni.navigateBack({
					delta: 1
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		background-color: #ffffff;
		width: 100%;
		height: 100vh;
		overflow-y: auto;

		.status_bar,
		.top_view {
			background-color: #FFFFFF;
		}

		.top_nav {
			padding-bottom: 24rpx;
			color: rgb(51, 51, 51);
			font-size: 34rpx;
			line-height: 41rpx;
			white-space: nowrap;
			background-color: rgb(255, 255, 255);
			box-shadow: 0px 6rpx 12rpx 0px rgba(0, 0, 0, 0.1);
			border-radius: 0px 0px 30rpx 30rpx;
			height: 90rpx;
			position: relative;

			.image_1 {
				left: 21rpx;
				top: 27rpx;
				width: 19rpx;
				height: 35rpx;
				position: absolute;
			}

			.cate {
				width: 100%;
				padding: 20rpx 0;
				color: rgb(51, 51, 51);
				font-size: 34rpx;
				font-weight: 500;
				line-height: 41rpx;
				white-space: nowrap;
				text-align: center;
			}
		}

		.group_1 {
			flex: 1 1 auto;
			color: rgb(51, 51, 51);
			font-size: 28rpx;
			line-height: 34rpx;
			white-space: nowrap;
			overflow-y: auto;

			.group_2 {
				padding: 40rpx 20rpx 37rpx;
			}

			.image_4 {
				width: 100vw;
				height: 0.5vw;
			}

			.top-group {
				padding: 38rpx 20rpx 37rpx;
			}

			.image_2 {
				margin-bottom: 4rpx;
				width: 16rpx;
				height: 28rpx;
			}

			.like {
				position: relative;
			}

			.have_mark::after {
				content: '';
				position: absolute;
				width: 16rpx;
				height: 16rpx;
				background-color: #fa3534;
				border-radius: 50%;
				right: -28rpx;
				top: 56%;
				transform: translate(0, -50%);
			}
		}
	}
</style>
